module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-version",
    style: ({
      'height': _vm.deviceHeight
    })
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.store.sysInfo && _vm.store.sysInfo.logo || ''
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.store.sysInfo && _vm.store.sysInfo.name || '风行供货商EDI'))]), _vm._v(" "), _c('h5', [_vm._v("v 1.0.0.0012")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61d8df53!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Version.vue
// module id = 578
// module chunks = 1